import classNames from 'classnames';
import React from 'react';

export interface ReportingBadgeProps {
  label: string;
  variant: 'success' | 'warning' | 'danger' | 'info' | 'neutral';
}

const VARIANT_CLASSES: Record<ReportingBadgeProps['variant'], string> = {
  success: 'bg-emerald-50 text-emerald-700',
  warning: 'bg-amber-50 text-amber-700',
  danger: 'bg-red-50 text-red-600',
  info: 'bg-blue-50 text-blue-700',
  neutral: 'bg-gray-100 text-gray-600',
};

export const ReportingBadge: React.FC<ReportingBadgeProps> = ({ label, variant }) => (
  <span
      className={classNames(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        VARIANT_CLASSES[variant],
      )}
  >
    { label }
  </span>
);
